import SEP from "@/services/bridgingVclaim/SEP";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

@Module({ store, dynamic: true, name: "storeSEP" })
class SEPStore extends VuexModule {
  riwayatSEP = [];
  lastNoSEP={};
  sep={}
  loading=false

  @Mutation SET_RIWAYAT_SEP(riwayatSEP) {
    this.riwayatSEP = riwayatSEP;
  }

  @Mutation SET_LAST_RIWAYAT_SEP(lastNoSEP) {
    this.lastNoSEP = lastNoSEP;
  }

  @Mutation SET_SEP(sep) {
    this.sep = sep;
  }
  
  @Mutation SET_LOADING(loading) {
    this.loading = loading;
  }

  @Action act_get_sep(no) {
    const dt = SEP.getSEP(no)
    dt.then(dt => {
      const sep = dt.data
      // console.log('sep',sep)
      if(sep){
        this.SET_SEP(sep);
      } else {
        this.SET_SEP({});
      }
    });
  }

  @Action act_riwayat_sep(param) {
    this.SET_RIWAYAT_SEP([]);
    this.SET_LOADING(true)
    const dt = SEP.riwayat(param["nomor"],param["tgl_awal"],param["tgl_akhir"])
    dt.then(dt => {
      const riwayatSEP = dt.data
      if(riwayatSEP){
        this.SET_RIWAYAT_SEP(riwayatSEP);
      } else {
        this.SET_RIWAYAT_SEP([]);
      }
      this.SET_LOADING(false)
    });
  }

  @Action act_last_riwayat_sep(param) {
    const dt = SEP.riwayat(param["nomor"],param["tgl_awal"],param["tgl_akhir"])
    dt.then(dt => {
      const riwayatSEP = dt.data
      if(riwayatSEP){
        // const lgh = riwayatSEP.histori.length
        // console.log("hasil",riwayatSEP.histori[lgh-1])
        // this.SET_LAST_RIWAYAT_SEP(riwayatSEP.histori[lgh-1]);
        this.SET_LAST_RIWAYAT_SEP(riwayatSEP.histori[0]);
      } else {
        this.SET_LAST_RIWAYAT_SEP({});
      }
    });
  }

  @Action act_clear_riwayat_sep() {
      this.SET_RIWAYAT_SEP([]);
      this.SET_SEP({});
      this.SET_LOADING(false)
  }


}

export const storeSEP = getModule(SEPStore);
